import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-second-otp',
  templateUrl: './second-otp.component.html',
  styleUrls: ['./second-otp.component.scss']
})
export class SecondOTPComponent implements OnInit {

  constructor(public router: Router) { }
  onSubmit() {

    if ($("#obaoform").valid()) {
      // this.router.navigate(['/second-director-details']);
      sessionStorage.setItem("contactInfo", "false");
      this.router.navigate(['/tell-us']);
    }
  }

  ngOnInit() {

    $(document).ready(function (){

      $("#obaoform").validate({
        rules: {
          otp_number_second: {
            required: true,
            number:true
          }
        },
        messages: {
    
          otp_number_second: {
            required: "Please enter otp numbers",
            number: "OTP must be in the form of numbers"
          }
  
        },  errorPlacement:function(error,element){
        
        if(element.attr("name")=="otp_number_second"){
          error.appendTo($("#otp_number_second_error_container"));
  }
        },
        submitHandler: function (form) {
          // $("#btn-next").prop("disabled", true);
        }
  
  
      });

    })
  }

}
